export const siteMeta = {
  name: "黑料大全",
  tagline: "完整档案 · 深度整理",
  intro:
    "把散落在各处的线索收拢成一份可检索的档案：从背景挖掘到证据汇总，再到一条完整的时间线。我们只做整理，不替谁下结论。",
  notice:
    "档案区每日 09:00 更新编号索引，历史条目保持可回溯；涉及未成年人信息一律不入档。",
};

export const navCategories = [
  { key: "all", label: "全部档案" },
  { key: "timeline", label: "时间线" },
  { key: "evidence", label: "证据汇总" },
  { key: "context", label: "背景挖掘" },
  { key: "index", label: "合集索引" },
  { key: "topic", label: "话题墙" },
];

export const quickTags = [
  "商业纠纷",
  "合同争议",
  "直播风波",
  "作品署名",
  "资金流向",
  "团队内讧",
  "版权归属",
];

export const liveFeed = [
  "编号 A-2043 档案补入第 7 组证据截图，来源标注已核对",
  "时间线 1998 段落新增两处对照材料，前因脉络更完整",
  "合集《资本局中局》新增子索引 12 条，排序按时间归并",
  "话题墙「合同争议」热度上升，关联档案合并至同一分组",
  "编号 B-0117 完成背景回填，涉及三方公开声明的先后顺序",
  "证据汇总区更新 3 份财务口径对照表，标注差异说明",
];

export const focusCards = [
  {
    id: "A-2043",
    code: "A-2043",
    title: "一场持续十一年的商业纠纷：合同、注资与最终对簿",
    summary:
      "从最初的合作意向书，到中途三次股权变更，再到最终庭审记录，我们把每一份关键文件的签署时间做了对照，梳理出争议真正爆发的节点。",
    category: "商业纠纷",
    date: "2024-11-08",
    readTime: "深度长文 · 18 分钟",
    evidenceCount: 26,
    timelineNodes: 14,
    heat: 96,
    image:
      "https://readdy.ai/api/search-image?query=abstract%20editorial%20archival%20collage%20of%20layered%20contract%20papers%20and%20folders%20on%20a%20desk%2C%20muted%20warm%20beige%20and%20deep%20charcoal%20tones%2C%20soft%20directional%20studio%20light%2C%20minimal%20composition%2C%20no%20text%2C%20high%20detail&width=900&height=620&seq=archive-focus-a2043&orientation=landscape",
    featured: true,
  },
  {
    id: "B-0117",
    code: "B-0117",
    title: "三方公开声明的先后顺序，藏着整件事的转折点",
    summary:
      "谁先发声、谁在回应、谁沉默了十四天，时间上的错位比内容本身更说明问题。",
    category: "背景挖掘",
    date: "2024-10-29",
    readTime: "深度长文 · 12 分钟",
    evidenceCount: 17,
    timelineNodes: 9,
    heat: 88,
    image:
      "https://readdy.ai/api/search-image?query=abstract%20minimalist%20stack%20of%20folded%20newspaper%20columns%20and%20note%20cards%20on%20a%20neutral%20surface%2C%20warm%20sand%20and%20graphite%20palette%2C%20soft%20even%20lighting%2C%20clean%20editorial%20still%20life%2C%20no%20text%2C%20high%20detail&width=620&height=420&seq=archive-focus-b0117&orientation=landscape",
    featured: false,
  },
  {
    id: "C-0092",
    code: "C-0092",
    title: "资金流向对照表：同一笔款项的三种不同口径",
    summary:
      "财务口径、对外口径与监管口径之间存在的差额，我们用三栏并列的方式做了标注。",
    category: "证据汇总",
    date: "2024-10-17",
    readTime: "整理稿 · 9 分钟",
    evidenceCount: 31,
    timelineNodes: 6,
    heat: 81,
    image:
      "https://readdy.ai/api/search-image?query=abstract%20archival%20evidence%20board%20with%20pinned%20ledger%20sheets%20and%20tabular%20charts%2C%20muted%20terracotta%20and%20stone%20grey%20tones%2C%20soft%20diffuse%20light%2C%20structured%20grid%20composition%2C%20no%20text%2C%20high%20detail&width=620&height=420&seq=archive-focus-c0092&orientation=landscape",
    featured: false,
  },
  {
    id: "D-0356",
    code: "D-0356",
    title: "署名之争的十年前因：一纸未公开的合作备忘",
    summary:
      "如今被反复引用的那份作品归属，最早可以追溯到一次非正式的口头约定。",
    category: "版权归属",
    date: "2024-09-30",
    readTime: "背景梳理 · 15 分钟",
    evidenceCount: 22,
    timelineNodes: 11,
    heat: 74,
    image:
      "https://readdy.ai/api/search-image?query=abstract%20vintage%20manuscript%20pages%20and%20sealed%20envelopes%20arranged%20on%20linen%2C%20muted%20ochre%20and%20warm%20grey%20tones%2C%20soft%20window%20light%20with%20gentle%20shadow%2C%20calm%20editorial%20composition%2C%20no%20text%2C%20high%20detail&width=620&height=420&seq=archive-focus-d0356&orientation=landscape",
    featured: false,
  },
];

export const archiveCollections = [
  {
    no: "001",
    title: "资本局中局",
    count: 42,
    desc: "注资、对赌、股权变更的完整脉络对照",
    tags: ["商业纠纷", "资金流向"],
    updated: "2024-11-08",
    image:
      "https://readdy.ai/api/search-image?query=abstract%20archival%20folder%20set%20stacked%20with%20blank%20index%20divider%20tabs%2C%20warm%20beige%20and%20charcoal%20tones%2C%20soft%20studio%20light%2C%20neat%20organized%20composition%2C%20no%20text%2C%20high%20detail&width=520&height=360&seq=archive-col-001&orientation=landscape",
  },
  {
    no: "002",
    title: "合同争议图谱",
    count: 37,
    desc: "从意向书到终止函，逐份文件的签署顺序",
    tags: ["合同争议", "证据汇总"],
    updated: "2024-11-02",
    image:
      "https://readdy.ai/api/search-image?query=abstract%20minimal%20arrangement%20of%20clipped%20document%20bundles%20on%20a%20pale%20surface%2C%20muted%20sand%20and%20graphite%20palette%2C%20soft%20even%20lighting%2C%20quiet%20editorial%20still%20life%2C%20no%20text%2C%20high%20detail&width=520&height=360&seq=archive-col-002&orientation=landscape",
  },
  {
    no: "003",
    title: "风口之下",
    count: 28,
    desc: "行业周期与个人选择之间的时间错位",
    tags: ["背景挖掘", "时间线"],
    updated: "2024-10-26",
    image:
      "https://readdy.ai/api/search-image?query=abstract%20timeline%20strip%20of%20paper%20cards%20pinned%20in%20sequence%20on%20a%20neutral%20board%2C%20warm%20grey%20and%20soft%20amber%20tones%2C%20soft%20diffuse%20light%2C%20linear%20editorial%20composition%2C%20no%20text%2C%20high%20detail&width=520&height=360&seq=archive-col-003&orientation=landscape",
  },
  {
    no: "004",
    title: "署名与作品",
    count: 51,
    desc: "创作归属争议中反复出现的关键材料",
    tags: ["版权归属", "作品署名"],
    updated: "2024-10-19",
    image:
      "https://readdy.ai/api/search-image?query=abstract%20close%20view%20of%20layered%20manuscript%20sheets%20with%20folded%20corners%20on%20linen%2C%20muted%20ochre%20and%20warm%20taupe%20tones%2C%20soft%20window%20light%2C%20calm%20minimal%20composition%2C%20no%20text%2C%20high%20detail&width=520&height=360&seq=archive-col-004&orientation=landscape",
  },
];

export const archiveIndexRows = [
  { no: "A-2043", topic: "商业纠纷", level: "已归档", nodes: 14, date: "2024-11-08" },
  { no: "B-0117", topic: "背景挖掘", level: "整理中", nodes: 9, date: "2024-10-29" },
  { no: "C-0092", topic: "证据汇总", level: "已归档", nodes: 6, date: "2024-10-17" },
  { no: "D-0356", topic: "版权归属", level: "整理中", nodes: 11, date: "2024-09-30" },
  { no: "E-0228", topic: "合同争议", level: "已归档", nodes: 21, date: "2024-09-18" },
  { no: "F-0075", topic: "团队内讧", level: "已归档", nodes: 8, date: "2024-08-27" },
  { no: "G-0511", topic: "直播风波", level: "整理中", nodes: 16, date: "2024-08-14" },
  { no: "H-0199", topic: "资金流向", level: "已归档", nodes: 13, date: "2024-07-30" },
];

export const topicWall = [
  { label: "商业纠纷", count: 128, weight: "lg" },
  { label: "合同争议", count: 96, weight: "lg" },
  { label: "证据汇总", count: 84, weight: "md" },
  { label: "时间线梳理", count: 79, weight: "md" },
  { label: "版权归属", count: 71, weight: "md" },
  { label: "资金流向", count: 63, weight: "md" },
  { label: "背景挖掘", count: 58, weight: "sm" },
  { label: "直播风波", count: 47, weight: "sm" },
  { label: "团队内讧", count: 41, weight: "sm" },
  { label: "作品署名", count: 36, weight: "sm" },
  { label: "公开声明", count: 33, weight: "sm" },
  { label: "第三方证词", count: 29, weight: "sm" },
  { label: "融资对赌", count: 26, weight: "sm" },
  { label: "股权变更", count: 24, weight: "sm" },
  { label: "合作协议", count: 22, weight: "sm" },
  { label: "庭审记录", count: 19, weight: "sm" },
];

export const timelineEvents = [
  {
    year: "2009",
    date: "2009 · 春",
    title: "首次合作意向达成",
    desc: "一份未公开的意向书为后续十余年的纠纷埋下最早的伏笔。",
    tag: "背景起点",
    side: "left",
  },
  {
    year: "2013",
    date: "2013 · 夏",
    title: "第一轮注资与股权调整",
    desc: "注资完成后，原有口头约定第一次被写进正式文件条款。",
    tag: "资金流向",
    side: "right",
  },
  {
    year: "2016",
    date: "2016 · 冬",
    title: "对赌条款触发",
    desc: "业绩未达预期，回购义务被激活，双方沟通记录出现明显分歧。",
    tag: "合同争议",
    side: "left",
  },
  {
    year: "2019",
    date: "2019 · 秋",
    title: "控制权争议公开化",
    desc: "第三份公开声明发布，三方口径首次在同一周内正面碰撞。",
    tag: "公开声明",
    side: "right",
  },
  {
    year: "2022",
    date: "2022 · 春",
    title: "审计材料浮出水面",
    desc: "两组财务口径的差额被整理成对照表，成为后来的核心证据。",
    tag: "证据汇总",
    side: "left",
  },
  {
    year: "2024",
    date: "2024 · 秋",
    title: "庭审记录完成归档",
    desc: "全部关键文件按时间归并，档案编号 A-2043 完成最终整理。",
    tag: "归档",
    side: "right",
  },
];

export const evidenceBoard = [
  {
    type: "书面文件",
    icon: "ri-file-text-line",
    title: "合作意向书（影印件核对版）",
    source: "公开渠道 · 已标注来源",
    status: "已核对",
    note: "签署时间与后续声明存在两日差异，已标注待复核。",
  },
  {
    type: "财务口径",
    icon: "ri-line-chart-line",
    title: "三轮注资的金额对照表",
    source: "整理汇总 · 保留原始出处",
    status: "存在差异",
    note: "同一笔款项在外对口径与监管口径之间相差一处小数点。",
  },
  {
    type: "时间证据",
    icon: "ri-time-line",
    title: "三方声明的发布顺序记录",
    source: "公开发布 · 已存档快照",
    status: "已核对",
    note: "第二与第三次声明之间相隔十四天，期间无任何公开回应。",
  },
  {
    type: "往来记录",
    icon: "ri-chat-3-line",
    title: "沟通过程的片段整理",
    source: "第三方转述 · 待交叉验证",
    status: "待验证",
    note: "仅作线索使用，尚缺少可对应的原始记录。",
  },
  {
    type: "庭审材料",
    icon: "ri-scales-3-line",
    title: "庭审记录的争议焦点摘录",
    source: "公开庭审 · 申请后公开",
    status: "已核对",
    note: "双方对同一条款的理解分歧，被完整保留在摘录中。",
  },
  {
    type: "第三方证词",
    icon: "ri-user-voice-line",
    title: "关联方的两份书面说明",
    source: "主动提供 · 已确认身份",
    status: "待验证",
    note: "两份说明在关键日期上互相印证，其余细节仍有出入。",
  },
];

export const deepDiveArticles = [
  {
    kicker: "背景挖掘",
    title: "为什么同一件事，会有三种完全不同的说法",
    desc: "叙述的差异往往不在事实本身，而在讲述者所处的位置与时间。",
    readTime: "12 分钟",
    image:
      "https://readdy.ai/api/search-image?query=abstract%20editorial%20collage%20of%20overlapping%20paper%20layers%20with%20soft%20fold%20shadows%2C%20warm%20sand%20and%20graphite%20palette%2C%20soft%20diffuse%20studio%20light%2C%20minimal%20composition%2C%20no%20text%2C%20high%20detail&width=680&height=440&seq=deepdive-01&orientation=landscape",
  },
  {
    kicker: "深度整理",
    title: "把一百多条线索压缩成一张时间表的思路",
    desc: "整理不是堆材料，而是决定哪些节点必须留下、哪些可以合并。",
    readTime: "9 分钟",
    image:
      "https://readdy.ai/api/search-image?query=abstract%20neat%20row%20of%20index%20cards%20and%20small%20paper%20tabs%20on%20a%20pale%20board%2C%20muted%20taupe%20and%20warm%20grey%20tones%2C%20soft%20even%20lighting%2C%20ordered%20editorial%20composition%2C%20no%20text%2C%20high%20detail&width=680&height=440&seq=deepdive-02&orientation=landscape",
  },
  {
    kicker: "证据汇总",
    title: "一份材料「可信」到什么程度，该怎么标注",
    desc: "我们给每条证据都加了来源与核验状态，而不是简单贴上结论。",
    readTime: "10 分钟",
    image:
      "https://readdy.ai/api/search-image?query=abstract%20close%20view%20of%20stamped%20documents%20and%20paper%20clips%20arranged%20in%20rows%2C%20muted%20ochre%20and%20stone%20grey%20tones%2C%20soft%20side%20light%2C%20calm%20minimal%20composition%2C%20no%20text%2C%20high%20detail&width=680&height=440&seq=deepdive-03&orientation=landscape",
  },
];

export const statsStrip = [
  { value: "1,284", label: "已归档条目" },
  { value: "6,730", label: "整理素材条目" },
  { value: "312", label: "时间线节点" },
  { value: "96%", label: "材料带来源标注" },
];

export const footerColumns = [
  {
    title: "档案分区",
    links: ["时间线", "证据汇总", "背景挖掘", "合集索引", "话题墙"],
  },
  {
    title: "热门索引",
    links: ["资本局中局", "合同争议图谱", "风口之下", "署名与作品", "全部合集"],
  },
  {
    title: "整理规范",
    links: ["来源标注说明", "核验状态定义", "隐私与合规", "纠错通道", "更新日志"],
  },
];